import { useEffect, useRef, useState } from "react";
import {
  setUserProfilePhoto,
  updateUser,
  getUserPublicProfileInfo,
  getProfilePhotoUrl,
} from "../firebase/firebase";
import DashboardWrapper from "../components/dashboardWrapper";
import { useNavigate } from "react-router-dom";

import style from "./editProfile.module.css";
import AuthProvider from "../components/authProvider";

export default function EditProfile() {
  const ref = useRef(null);
  const [profileUrl, setProfileUrl] = useState(undefined);
  const [currentUser, setCurrentUser] = useState(null);
  const [username, setUsername] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [profileLink, setProfileLink] = useState("");
  const [isLoadingImage, setIsLoadingImage] = useState(true);

  let navigate = useNavigate();

  function handleOnClickProfilePicture() {
    ref.current.click();
  }

  function handleOnChangeProfileImage(e) {
    var fileList = e.target.files;
    var fileReader = new FileReader();

    if (fileReader && fileList && fileList.length) {
      fileReader.readAsArrayBuffer(fileList[0]);
      fileReader.onload = async function () {
        var imageData = fileReader.result;

        const res = await setUserProfilePhoto(currentUser.uid, imageData);

        if (res) {
          const tmpUser = { ...currentUser };
          tmpUser.profilePicture = res.metadata.fullPath;
          setCurrentUser({ ...tmpUser });
          await updateUser(currentUser);
          const url = await getProfilePhotoUrl(currentUser.profilePicture);
          setProfileUrl(url);
        }
      };
    }
  }

  async function handleOnUserLoggedIn(loggedUser) {
    setCurrentUser(loggedUser);
    setUsername(loggedUser.username);
    const url = await getProfilePhotoUrl(loggedUser.profilePicture);
    setProfileUrl(url);
    setProfileLink(`https://nex-link.netlify.app/u/${loggedUser.username}`);
  }

  function handleOnUserNotLoggedIn() {
    navigate("/login");
  }

  function handleUsernameChange(e) {
    const lowerCaseUsername = e.target.value.toLowerCase();
    setUsername(lowerCaseUsername);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    try {
      if (currentUser && username) {
        const updatedUser = { ...currentUser, username };
        await updateUser(updatedUser);
        setCurrentUser(updatedUser);
        setSuccessMessage("¡Perfil actualizado exitosamente!");
        setProfileLink(`https://nex-link.netlify.app/u/${updatedUser.username}`);
      }
    } catch (error) {
      console.error("Error al actualizar el perfil", error);
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleCopyLink = () => {
    navigator.clipboard.writeText(profileLink).then(() => {
      alert("Enlace copiado al portapapeles");
    });
  };

  useEffect(() => {
    if (profileUrl) {
      setIsLoadingImage(false);
    }
  }, [profileUrl]);

  return (
    <AuthProvider
      onUserLoggedIn={handleOnUserLoggedIn}
      onUserNotLoggedIn={handleOnUserNotLoggedIn}
    >
      <DashboardWrapper>
        <div>
          <h2>Editar Perfil</h2>
          <div className={style.profilePictureContainer}>
            <div>
              {isLoadingImage ? (
                <div className={style.loader}></div>
              ) : (
                <img src={profileUrl} alt="Perfil" width={100} />
              )}
            </div>
            <div>
              <button className="btn" onClick={handleOnClickProfilePicture}>
                Agregar nueva foto de perfil
              </button>
              <input
                ref={ref}
                type="file"
                onChange={handleOnChangeProfileImage}
                className={style.fileInput}
              />
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="username">Nombre de Usuario:</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={handleUsernameChange}
                placeholder="Introduce tu nombre de usuario"
                disabled={isSubmitting}
              />
            </div>
            <button type="submit" className="btn" disabled={isSubmitting}>
              {isSubmitting ? "Actualizando..." : "Actualizar Nombre de Usuario"}
            </button>
          </form>
          {successMessage && (
            <div className={style.successMessage}>
              {successMessage}
              <p>
                <a href={profileLink} target="_blank" rel="noopener noreferrer">
                  Ver mi perfil
                </a>
              </p>
              <button onClick={handleCopyLink} className="btn">
                Copiar enlace del perfil
              </button>
            </div>
          )}
        </div>
      </DashboardWrapper>
    </AuthProvider>
  );
}
